<template lang="pug">
  include ../../../../pug/mixins/bem.pug
  filterable-list(:url='newUrl', 
                  :naviagatable='false', )
    template(slot-scope="props")
      slot(name='render', )
      div(v-for='item in props.items.data')
        renderer(:result='item')              
      //- slot(name='render', v-if='!props.items.data') 
      load-more(:page='props.items.meta ? props.items.meta.pagination : {}'
                :current='page',
                v-if='hasNext=="True"'
                @paginate='pagination($event)' )                 
</template>

<script>

const locale = document.documentElement.lang
export default {
  name: 'VideosPage',
  props: {
    hasNext: {
      type: String
    },
    isPaginated: {

    }
  },
  data() {
    return {
      newUrl: "",
      page: 1
    }
  },
  mounted() {
    // this.pagination(this.page)
  },
  methods: {
    pagination(page) {
      this.page = page
      this.newUrl = `/${ locale}/videos/?page=${page}`
      
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/js/shared/components/videos/VideosPage.vue